import { useEffect, useState } from "react";

/*
  Fragt ab, ob der Bildschirm breit genug für die zweispaltige Ansicht ist.

  Der Umschaltpunkt liegt bei 1024 Pixeln. Damit gilt:
    iPad im Querformat  → zwei Spalten (Tagesordnung links, Inhalt rechts)
    iPad im Hochformat  → eine Spalte, wie auf dem Handy
    Handy               → eine Spalte

  Das entspricht dem Verhalten, das man von Mail oder Notizen auf dem iPad
  kennt: im Hochformat weicht die Liste, im Querformat bleibt sie stehen.
*/

export const BREITE_ANSICHT = "(min-width: 64rem)";

export function useMedienabfrage(abfrage) {
  const [trifftZu, setzeTrifftZu] = useState(
    () => typeof window !== "undefined" && window.matchMedia(abfrage).matches
  );

  useEffect(() => {
    const abgleich = window.matchMedia(abfrage);
    const beiAenderung = (ereignis) => setzeTrifftZu(ereignis.matches);
    setzeTrifftZu(abgleich.matches);
    abgleich.addEventListener("change", beiAenderung);
    return () => abgleich.removeEventListener("change", beiAenderung);
  }, [abfrage]);

  return trifftZu;
}
